<script>
    import { formattedDateAndTime } from "../../utils/date";
    import { getSnippetUrlPreview } from "../../utils/Utils";

    export let snippet;
    export { formattedDateAndTime } from "../../utils/date";

    // prettify url preview
    let pageUrl = getSnippetUrlPreview(snippet.url);

    $: sortedComments = snippet.comments.sort((a, b) => {
        return a.createdOn - b.createdOn;
    });
</script>

<a class="snippet-url" href={snippet.url} target="_blank" rel="noreferrer">
    {pageUrl}
</a>

{#if snippet.name}
    <h3 class="snippet-name">
        {snippet.name}
    </h3>
{/if}

<p class="snippet-content">
    {@html snippet.content}
</p>

{#each sortedComments as comment}
    <blockquote class="comment">
        {#if comment.createdBy}
            <div class="comment__header">
                {comment.createdBy.firstName}
                {comment.createdBy.lastName} &nbsp-&nbsp;
                {formattedDateAndTime(comment.createdOn)}
            </div>
        {/if}

        <div class="comment__content">
            {@html comment.comment}
        </div>
    </blockquote>
{/each}

<style>
    @import "../../main.css";

    .snippet-url {
        @apply text-sm underline;
    }

    .snippet-name {
        @apply text-lg font-bold;
    }

    .comment {
        @apply border-l-neutral-500 !important;
    }

    .comment__content {
        @apply not-italic;
    }

    .comment__header {
        @apply text-sm italic text-gray-700;
    }
</style>
